import "./global.css";
import "./theme/theme.css";
import "./locales/i18n";
import ReactDOM from "react-dom/client";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router";
import App from "./App";
import menuService from "./api/services/menuService";
import { registerLocalIcons } from "./components/icon";
import { GLOBAL_CONFIG } from "./global-config";
import ErrorBoundary from "./routes/components/error-boundary";
import { routesSection } from "./routes/sections";
import { urlJoin } from "./utils";

const shouldEnableMocking = import.meta.env.DEV && import.meta.env.VITE_ENABLE_MSW === "true";

await registerLocalIcons();

if (shouldEnableMocking) {
	try {
		const { worker } = await import("./_mock");
		await worker.start({
			onUnhandledRequest: "bypass",
			serviceWorker: {
				url: urlJoin(GLOBAL_CONFIG.publicPath, "mockServiceWorker.js"),
				options: {
					scope: GLOBAL_CONFIG.publicPath,
				},
			},
		});
	} catch (error) {
		console.warn("MSW (Mock Service Worker) failed to start:", error);
	}
}
if (GLOBAL_CONFIG.routerMode === "backend") {
	await menuService.getMenuList();
}

const router = createBrowserRouter(
	[
		{
			Component: () => (
				<App>
					<Outlet />
				</App>
			),
			errorElement: <ErrorBoundary />,
			children: routesSection,
		},
	],
	{
		basename: GLOBAL_CONFIG.publicPath,
	},
);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<RouterProvider router={router} />);
